/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Order_Has_Partial_ReturnInputs */

const vi_error_order_has_partial_return = /** @type {(inputs: Error_Order_Has_Partial_ReturnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn đã có phiếu trả hàng nên không huỷ/hoàn toàn bộ được nữa. Hãy tạo phiếu trả hàng cho phần còn lại.`)
};

/**

* @param {Error_Order_Has_Partial_ReturnInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_order_has_partial_return = /** @type {((inputs?: Error_Order_Has_Partial_ReturnInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Order_Has_Partial_ReturnInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_order_has_partial_return(inputs)
});